import React, { Component } from "react";
import Modal from "./Modal";
import EditableInput from "../../atoms/EditableInput";
import Button from "../../atoms/Button";
import Link from "../../atoms/Link";
import SocialLimits from "../../atoms/SocialLimits";
import { getCommentWithFields } from "../../pages/articles/sharedArticle";

export default class MultipleCommentsModal extends Component<
    {
        className?: string;
        disableSuggestions?: boolean;
        suggestedComments: string[];
        url: string;
        lang: string;
        open?: boolean;
        client?: Mongo.IClient;
        facebookMaxLength: number;
        linkedInMaxLength: number;
        twitterMaxLength: number;
        instaMaxLength: number;
        update: (comments: string[]) => void;
        close: () => void;
        comment: string;
        quotes: string[];
        addedImage?: boolean;
        image?: string;
        sURLDomain: string;
        commentURL: string;
        commentURLLength?: number;
        hashtagsAndMentions: string[];
        },
    {
        open: boolean;
        comments: string[];
        quotes: string[]
    }
> {
    constructor(props) {
        super(props);

        this.close = this.close.bind(this);
        this.state = {
            open: props.open || false,
            comments: [
                ...(props.suggestedComments && props.suggestedComments.length
                    ? props.suggestedComments.filter(i => i.length)
                    : []),
                "",
                "",
                ""
            ].slice(0, 3),
            quotes: this.props.quotes,
        };
        if (this.props.comment) {
            this.updateComment(0, this.props.comment);
        }
    }

    componentWillReceiveProps(newProps) {
        if ("open" in newProps && newProps.open !== this.state.open) {
            this.setState({ open: newProps.open, quotes: newProps.quotes });
            if (newProps.comment) {
                this.updateComment(0, newProps.comment);
            }
        }
    }

    close() {
        this.setState({ open: false });
        if (this.props.close) {
            this.props.close();
        }
    }
    updateComment(index: number, comment: string) {
        const { comments } = this.state;
        if (comments.length < index + 1) {
            comments.push(comment);
        } else {
            comments[index] = comment;
        }
        this.setState({ comments });
    }

    renderComment(index: number, comment: string) {
        const { quotes } = this.state;
        const { client, facebookMaxLength, linkedInMaxLength, twitterMaxLength, url, lang, disableSuggestions, addedImage, image, sURLDomain, commentURL, hashtagsAndMentions} = this.props;
        return (
            <div className="form__row">
                            <div className="form__group form__group--full">
                                <label htmlFor="commentSuggestion" className="form__label">Comment Suggestion {index + 1}:</label>{" "}
                                {client && client.aiGeneratedAdminSuggestions && lang === "en" && !disableSuggestions && (
                                    <div className="select__wrapper" style={{ marginBottom: "10px" }}>
                                        <select
                                            id="commentSuggestion"
                                            onChange={event => {
                                                const value = (event.target.value || "").trim();
                                                if (value === "starters") {
                                                    this.updateComment(index, "");
                                                } else if (value !== "suggested") {
                                                    this.updateComment(index, value);
                                                }
                                            }}
                                            value="starters"
                                        >
                                            <option value="starters">Starters</option>
                                            {quotes && quotes.length > 0 ? quotes.map((suggestedComment, i) => (
                                                <optgroup label={`${i == 0 ? "Suggested Comments" : "---"}`}>
                                                    <option value={suggestedComment}>
                                                        {suggestedComment.slice(0, 70)}
                                                        {suggestedComment.length > 70 ? "..." : ""}
                                                    </option>
                                                </optgroup>
                                            )) : <optgroup label="...we found no Suggested Comments" />}
                                        </select>
                                    </div>
                                )}
                                <EditableInput
                                    id={`ai_comment_${index}`}
                                    value={comment}
                                    onChange={event => this.updateComment(index, event.target.value)}
                                    style={{ height: "100px", overflowY: "scroll" }}
                                />
                                <div style={{ display: "flex" }}>
                                    <Link
                                        style={{ marginLeft: "10px", textDecoration: "underline" }}
                                        onClick={() => this.updateComment(index, "")}
                                    >
                                        Clear
                                    </Link>
                                    <SocialLimits
                                        client={client}
                                        facebookMaxLength={facebookMaxLength}
                                        linkedInMaxLength={linkedInMaxLength}
                                        twitterMaxLength={twitterMaxLength}
                                        url={url}
                                        comment={getCommentWithFields(comment, commentURL, hashtagsAndMentions)}
                                        addedImage={addedImage}
                                        image={image}
                                        sURLDomain={sURLDomain}
                                    />
                                </div>
                            </div>
                        </div>
        );
    }

    render() {
        const { comments } = this.state;
        return (
                <Modal
                    open={this.state.open}
                    className={this.props.className || ""}
                    title={`Comment suggestions`}
                    closeAction={this.close}
                >
                    {
                        <div>
                          <div>
                        {comments && comments.map((cmt, index) => this.renderComment(index, cmt))}
                        <div className="form__row">
                            <div
                                className="form__group form__group--full"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "row"
                                }}
                            >
                                <Button
                                    id="multiple_comments"
                                    style={{ marginLeft: "auto" }}
                                    onClick={() => {
                                        if (this.props.update) {
                                            this.props.update(comments);
                                        }
                                        this.close();
                                    }}
                                >
                                    Update
                                </Button>
                            </div>
                        </div>
                          </div>
                        </div>
                    }

                </Modal>
            );
     }
}
